module.exports = __webpack_public_path__ + "static/pic02-b4378120bdfa80c6d71eea4e4142d51a.jpg";